import React from "react";
import { IonSkeletonText } from "@ionic/react";

export const DepositSkeleton: React.FC = () => {
  return (
    <div className="flex h-full w-full flex-col">
      <div className="flex w-full flex-col gap-y-8">
        <div className="flex w-full flex-col gap-y-2">
          <IonSkeletonText animated className="h-8 w-[400px] rounded-lg" />
          <IonSkeletonText animated className="h-8 w-[400px] rounded-lg" />
        </div>
        <div className="flex w-full flex-col gap-y-2">
          <IonSkeletonText animated className="h-8 w-[400px] rounded-lg" />
          <IonSkeletonText animated className="h-8 w-[400px] rounded-lg" />
        </div>
      </div>
    </div>
  );
};
